import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    position: 'relative',
    padding: theme.spacing(4),
  },
  buttonContainer: {
    maxWidth: 1000,
    margin: '0 auto 10px',
  },
  formStyle: {
    alignItems: 'flex-start !important',
    position: 'relative',
    maxWidth: '1000px !important',
    overflow: 'visible !important',
  },
  titleStyle: {
    fontSize: '18px !important',
    fontWeight: 'bold',
  },
  chip: {
    backgroundColor: theme.palette.action.disabledBackground,
    marginRight: 5,
  },
  chipIcon: {
    color: '#57b400',
    width: '1em',
    height: '1em',
  },
  screenWidth: {
    marginRight: theme.spacing(2),
  },
  screenContainer: {},
  screenContainerMobile: {
    maxWidth: 'none !important',
  },
  accessContainer: {
    width: '100%',
    padding: theme.spacing(2),
  },
  dropZone: {
    border: `1px solid ${theme.colors.disabledGray} !important`,
    borderRadius: `4px  !important`,
    minHeight: 'auto !important',
    backgroundColor: `${theme.colors.transparent}  !important`,
    '&:hover': {
      border: `1px solid ${theme.palette.text.primary} !important`,
    },
    '& p': {
      fontSize: '14px !important',
      textAlign: 'left !important',
      padding: `${theme.spacing(1)}px ${theme.spacing(2)}px !important`,
    },
    '& > div > svg': {
      display: 'none !important',
    },
  },
  dropIcon: {
    position: 'absolute',
    right: 9,
    top: 17,
    color: theme.palette.primary.main,
  },
  deleteButton: {
    backgroundColor: theme.colors.danger,
    marginLeft: theme.spacing(1),
  },
}));

export default useStyles;
